import { render, staticRenderFns } from "./ConsultationsDeSuiviEdit.vue?vue&type=template&id=23bf99c1&"
import script from "./ConsultationsDeSuiviEdit.vue?vue&type=script&lang=js&"
export * from "./ConsultationsDeSuiviEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports